import { HUBSPOT_SERVICE_DOC_FORM_ID } from "../api/hubspot";
import AiLpFormPage from "./AiLpFormPage";

// サービス資料の請求ページ。
//
// 以前は「ご入力のメールアドレスにお送りします」と書いていたが、
// 送る仕組みも資料の実体も無く、入力しても何も届かない状態だった。
// 実務資料3点（/download）と同じく、完了画面で直接渡す形に統一する。
//
// ※資料そのものは未完成。SERVICE_DOC.ready を true にするまで、
//   完了画面は「担当より営業日以内にお送りします」と正直に出す。
//   ファイルを public/downloads/ に置いたら ready を true にすること。
const SERVICE_DOC = {
  ready: false,
  title: "LEAPS AI導入支援 サービス資料",
  meta: "PDF",
  href: "/downloads/leaps-service-deck.pdf",
};

function AiAdoptionDocument() {
  // 自動返信はHubSpotの有料プランが要るため入れていない。
  // 資料が出来るまでは人が送るので、急ぎの人が待たされないよう
  // 直接の連絡先を添えておく。
  const doneMsg = SERVICE_DOC.ready
    ? "下のボタンからダウンロードいただけます。"
    : "担当より、営業日以内にご入力のメールアドレスへお送りします。お急ぎの場合は info@leaps-inc.com へご連絡ください。";

  return (
    <AiLpFormPage
      leadKind="document"
      eyebrow="サービス資料"
      title="サービス資料をお送りします"
      lead="サービス概要・導入事例・料金感をまとめた資料です。"
      fields={[
        { name: "company", label: "会社名", type: "text", required: true },
        { name: "name", label: "お名前", type: "text", required: true },
        {
          name: "email",
          label: "メールアドレス",
          type: "email",
          required: true,
        },
        { name: "tel", label: "電話番号", type: "tel", required: false },
      ]}
      formId={HUBSPOT_SERVICE_DOC_FORM_ID || undefined}
      submitLabel="資料を請求する"
      doneTitle="ありがとうございます"
      doneMsg={doneMsg}
      doneExtra={
        SERVICE_DOC.ready ? (
          <div style={{ marginTop: 24 }}>
            <a
              href={SERVICE_DOC.href}
              download
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "14px 28px",
                borderRadius: 999,
                background: "#2B7FFF",
                color: "#fff",
                fontSize: 15,
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              {SERVICE_DOC.title}（{SERVICE_DOC.meta}）
            </a>
          </div>
        ) : null
      }
    />
  );
}

export default AiAdoptionDocument;
